import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const UNSAFE_METHODS = new Set(['post', 'put', 'patch', 'delete']);
let csrfToken = null;
let csrfRequest = null;

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

async function getCsrfToken() {
  if (csrfToken) return csrfToken;
  if (!csrfRequest) {
    csrfRequest = apiClient
      .get('/api/auth/csrf', { skipCsrf: true })
      .then(response => {
        csrfToken = response.data.csrfToken;
        return csrfToken;
      })
      .finally(() => {
        csrfRequest = null;
      });
  }
  return csrfRequest;
}

apiClient.interceptors.request.use(async config => {
  const method = String(config.method || 'get').toLowerCase();
  if (!config.skipCsrf && UNSAFE_METHODS.has(method)) {
    const token = await getCsrfToken();
    config.headers = config.headers || {};
    config.headers['x-csrf-token'] = token;
  }
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      csrfToken = null;
    }
    return Promise.reject(error);
  }
);

export function clearCsrfToken() {
  csrfToken = null;
}

export default apiClient;
